<template>
    <section>
        <div class="nutrition-list-item">
            <div class="nutrition-list-item-name">{{name}}</div>
            <div class="nutrition-list-item-buttons">
                <b-field grouped>
                    <b-field horizontal class="is-small">
                        <b-checkbox v-model="yes">Assigned</b-checkbox>
                    </b-field>
                </b-field>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "ClientSupplementsInstructionItem",
        props: {
            id: Number,
            user_id: String,
        },
        computed: {
            ...mapGetters(['getClientSupplementsInstruction']),
            name() {
                const supplement = this.getClientSupplementsInstruction(this.id);
                if (supplement !== undefined )
                    return supplement.name
                else
                    return ''
            },
            yes: {
                get() {
                    const supplement = this.getClientSupplementsInstruction(this.id);
                    if (supplement !== undefined) {
                        return supplement.assigned == 1;
                    }
                    return false
                },
                set(value) {
                    this.updateSupplementsInstruction(value);
                }
            },
        },
        methods:{
            async updateSupplementsInstruction(assignValue) {
                let role = 0;
                if (assignValue===true) role = 1;
                let oldInstruction = this.getClientSupplementsInstruction(this.id);
                let nutritionInstruction = {};
                if (oldInstruction === undefined ) {
                    nutritionInstruction.item_id = this.id;
                } else {
                    nutritionInstruction = Object.assign({}, oldInstruction);
                }
                nutritionInstruction.assigned = role;
                await this.$store.dispatch("CLIENT_SUPPLEMENTS_INSTRUCTION_UPDATE", {user: this.user_id, instruction: nutritionInstruction});
                this.$emit('update')
            }
        }
    }
</script>

<style scoped>
    .nutrition-list-item {
        height: 45px;
        padding: 7px;
        margin: 2px;
        border: 1px solid lightgray;
    }

    .nutrition-list-item-name {
        font-weight: bold;
        float: left;
        padding-left: 10px;
    }

    .nutrition-list-item-buttons {
        float: right;
        padding-right: 5px;
    }
</style>